import * as React from 'react'
const LMAccommodation = () => (
  <svg
    width={40}
    height={33}
    viewBox="0 0 12.333314 7.6408518"
    fill="currentColor"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g id="layer1" transform="translate(-125.39468,-145.85115)">
      <rect
        style={{
          display: "none",
          fill: "#280b0b",
          stroke: "#ffffff",
          strokeWidth: 0.529167,
          strokeLinejoin: "round",
        }}
        id="rect9"
        width={209.38908}
        height={297.40347}
        x={-0.35489929}
        y={-12.06649}
      />
      <g
        id="g130"
        style={{
          fill: "var(--primary)",
        }}
      >
        <g
          id="g10"
          transform="matrix(0.921305,0,0,1,45.765894,-34.870542)"
          style={{
            fill: "var(--primary)",
          }}
        >
          <g
            id="g6"
            style={{
              fill: "var(--primary)",
              fillOpacity: 1,
            }}
          >
            <rect
              style={{
                fill: "var(--primary)",
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 0.397485,
                strokeLinejoin: "round",
              }}
              id="rect3"
              width={1.3620284}
              height={7.8608489}
              x={86.430428}
              y={180.72169}
            />
            <rect
              style={{
                fill: "var(--primary)",
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 0.23895,
                strokeLinejoin: "round",
              }}
              id="rect4"
              width={1.3620284}
              height={2.8408017}
              x={98.305611}
              y={185.74174}
            />
            <rect
              style={{
                fill: "var(--primary)",
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 0.495576,
                strokeLinejoin: "round",
              }}
              id="rect6"
              width={1.3620284}
              height={12.219339}
              x={185.59749}
              y={-99.63369}
              transform="rotate(90)"
            />
          </g>
          <g
            id="g9"
            style={{
              fill: "var(--accent)",
            }}
          >
            <path
              id="rect8"
              style={{
                fill: "var(--accent)",
                fillOpacity: 1,
                strokeWidth: 0.418571,
                strokeLinejoin: "round",
              }}
              d="m 91.68396,181.85023 h 4.82547 a 3.2119715,3.2119715 43.264296 0 1 3.307785,3.11321 H 91.68396 Z"
            />
            <ellipse
              style={{
                fill: "var(--accent)",
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 0.418571,
                strokeLinejoin: "round",
              }}
              id="path9"
              cx={89.816032}
              cy={183.40683}
              rx={1.4009434}
              ry={1.3620282}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default LMAccommodation
